import React, {Fragment, useEffect, useMemo, useState} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import FilterListIcon from '@mui/icons-material/FilterList';
import SvgIcon from "@mui/material/SvgIcon";
import InfoIcon from "@mui/icons-material/Info";
import IconButton from "@mui/material/IconButton";
import UnpublishedIcon from '@mui/icons-material/Unpublished';

import {wizardSelectedValueInterface} from "../../../../interfaces/wizardItemInterface";
import {getFeatureGroupFromWizardGroup, getFilterValueThumbnailAndStyles} from "./lookWizard/lookWizardFunctions";
import FeatureThumbnail from "../../../visComponents/featureThumbnail";
import {setWizardActiveStep} from "../../../../actions/wizardFunctions";
import LookFeaturePrice from "./lookListFeature/lookFeaturePrice";
import {
  WIZARD_STEP_MOBILE_WIDTH,
  WIZARD_STEP_PRODUCT_JOURNEY,
  WIZARD_STEP_WIDTH
} from "../../core/constants";
import BathroomFeatureGroupsIcons from "../../../common/svgIcons/bathroomFeatureGroupIcons";
import FeatureName from "../../../visComponents/featureName";
import Misc from "../../../../misc/misc";
import {IS_PRODUCT_JOURNEY} from "../../../../config";
import {isInStock} from "../lookFunctions2";
import {getFeatureIsLocked} from "../../../../misc/helpers";
import {getCurrentLayout} from "../../../appLayout";
import {getWizardGroupName} from "./lookWizard/lookWizardFunctions2";

const LookMainWizardSelectedStep = (props) => {

  const {wizardSelectedValue, wizardActiveStep, stepIndex, allFilterGroups, setWizardActiveStep, isMobile, fabricatorData
  } = props;
  const fabricatorSettings = fabricatorData.settings;
  const [transform, setTransform] = useState(0);

  const isProductJourneyDesktop = IS_PRODUCT_JOURNEY && !isMobile;
  const isProductJourneyMobile = IS_PRODUCT_JOURNEY && isMobile;

  useEffect(() => {
    if (wizardSelectedValue && wizardActiveStep >= stepIndex) {
      // const currentGroups = getCurrentGroups(wizardActiveItem, wizardActiveStep, wizardSelectedValues);
      // const isCompletedStep = wizardActiveStep > -1 && !currentGroups.length;

      const addIndexes = wizardActiveStep - stepIndex;
      let transform = stepWidth * addIndexes;
      if (isProductJourneyMobile) {
        transform = -transform;
      }
      // if (isCompletedStep) {
      //   transform = transform - 320;
      // }
      setTransform(transform)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wizardActiveStep])

  const featureIsInStock = useMemo(() => {
    return wizardSelectedValue && wizardSelectedValue.selectedFeature ? isInStock(wizardSelectedValue.selectedFeature) : true
  }, [wizardSelectedValue]);

  const showPriceLocked = useMemo(() => {
    return wizardSelectedValue && wizardSelectedValue.selectedFeature ? getFeatureIsLocked(wizardSelectedValue.selectedFeature) : false
  }, [wizardSelectedValue]);

  const showPrice = useMemo(() => {
    const layout = getCurrentLayout();
    return wizardSelectedValue && wizardSelectedValue.selectedFeature
      ? fabricatorSettings.showPricing && !fabricatorData.hideCheckoutBreakdownCost && !showPriceLocked
      && !fabricatorData.hidePricesFromUser
      && layout.partIdExistInQtCategory(wizardSelectedValue.selectedFeature.partId, true)
      : true
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wizardSelectedValue]);

  if (!wizardSelectedValue) {
    return null
  }

  const stepWidth = isProductJourneyDesktop ? WIZARD_STEP_PRODUCT_JOURNEY : isMobile ? WIZARD_STEP_MOBILE_WIDTH : WIZARD_STEP_WIDTH;

  const {wizardGroup, selectedFeature, selectedFilter} = wizardSelectedValue;
  const isVisible = wizardActiveStep > stepIndex;
  const style = {
    transform: isProductJourneyDesktop ? `translateY(${transform}px)` : `translateX(${transform}px)`
  }

  const notSelected = !selectedFeature && !selectedFilter && stepIndex > 0 && (wizardGroup.nodeType !== "custom");

  const getThumbnail = () => {
    if (fabricatorData.isEncore && !isMobile) {
      return null
    }
    if (notSelected) {
      return (
        <div className={"look-icon " + (isMobile ? "look-icon--super-tiny" : " look-icon--medium")}>
          <UnpublishedIcon/>
        </div>
      )
    }

    if (wizardGroup.nodeType === "custom" && wizardGroup.customImageUrl && !isMobile) {
      const styles = {
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        borderRadius: "4px",
        backgroundImage: "url(" + wizardGroup.customImageUrl + ")",
      };
      return <div className="lw-step__thumbnail" style={styles}/>
    } else if (wizardGroup.nodeType === "filter") {
      if (isMobile) {
        return (
          <IconButton className={"look-icon look-icon--super-tiny"}>
            <FilterListIcon/>
          </IconButton>
        )
      }
      const filterGroup = allFilterGroups.find(group => group.id === selectedFilter.filterGroup_id);
      const {styles} = getFilterValueThumbnailAndStyles(selectedFilter, filterGroup || {});
      return <div className="lw-step__thumbnail" style={styles}/>
    } else if (wizardGroup.nodeType === "group") {
      const featureGroup = getFeatureGroupFromWizardGroup(wizardGroup);
      if (isMobile) {
        return (
          <IconButton className={"look-icon look-icon--super-tiny"}>
            {featureGroup && BathroomFeatureGroupsIcons[featureGroup.partId]
              ? <SvgIcon>{BathroomFeatureGroupsIcons[featureGroup.partId]}</SvgIcon>
              : <InfoIcon/>}
          </IconButton>
        )
      }
      const actFeature = wizardSelectedValue && wizardSelectedValue.selectedFeature
          ? wizardSelectedValue.selectedFeature
          : featureGroup ? featureGroup.activeNotInVisualizerFeature || featureGroup.activeFeature : null;
      if (!actFeature) {
        console.log("no featureGroup or no activeFeature", featureGroup);
        return <div className="lw-step__thumbnail"/>
      }
      return (
        <div className="lw-step__thumbnail">
          <FeatureThumbnail feature={actFeature} dbFeatureId={actFeature.dbFeature.id}/>
        </div>
      )
    }
    return isMobile
      ? <IconButton className={"look-icon look-icon--super-tiny"}><InfoIcon/></IconButton>
      : <div className="lw-step__thumbnail"/>
  }


  const stepName = getWizardGroupName(wizardGroup);

  return (
    <li className={(isProductJourneyDesktop ? "grohe-wizard__step" : "lw-step") + (isVisible ? " lw-step--visible" : "")}
        style={style}
        onClick={() => isProductJourneyDesktop ? null : setWizardActiveStep(stepIndex)}>
      {getThumbnail()}
      <div className={"lw-step__content" + (isMobile ? " lw-step__content--mobile" : "")}>
        <span className="lw-step__content-name">
          {Misc.textSubStringEllipsis(stepName, 32)}
        </span>
        {isMobile ? null : (
          <Fragment>
            {isProductJourneyDesktop && selectedFeature ? (
              <span className="lw-step__content-value">
                <FeatureName feature={selectedFeature} useCollectionName={true} maxLength={60}/>
              </span>
            ) : null}
            <span className="lw-step__content-value">
              {selectedFilter ? selectedFilter.displayText ? selectedFilter.displayText : selectedFilter.value : null}
              {showPrice && selectedFeature ? <LookFeaturePrice lookFeature={selectedFeature}/> : null}
              {!showPrice && selectedFeature ? <FeatureName feature={selectedFeature}
                                                            useCollectionName={true}
                                                            maxLength={60}/> : null}
              {notSelected ? <FormattedMessage id="wizard.step.notSelected"/> : null}
            </span>
            {featureIsInStock ? null : (
              <span className="lm-stock--red">
                <FormattedMessage id="look.feature.outOfStock"/>
              </span>
            )}
          </Fragment>
        )}
      </div>
      {isProductJourneyDesktop ? (
        <span className="grohe-wizard__step-edit" onClick={() => setWizardActiveStep(stepIndex)}>
          <FormattedMessage id="iconButton.edit"/>
        </span>
      ) : null}
    </li>
  )
};

LookMainWizardSelectedStep.propTypes = {
  stepIndex: PropTypes.number.isRequired,
  wizardSelectedValue: PropTypes.shape(wizardSelectedValueInterface).isRequired
}

const mapStateToProps = (store, ownProps) => {
  const {wizardActiveStep, wizardSelectedValues} = store.wizardState;
  const {filterGroups} = store.filterState;
  const {isMobile} = store.serverState;
  const {useMobile} = ownProps;
  const fabricatorData = store.fabricatorState;

  return {
    wizardActiveStep,
    // wizardSelectedValues,
    allFilterGroups: filterGroups,
    wizardSelectedValues,
    isMobile: (typeof useMobile !== "undefined") ? useMobile : isMobile,
    fabricatorData,
  };
};

const mapDispatchToProps = {
  setWizardActiveStep
};

export default connect(mapStateToProps, mapDispatchToProps)(LookMainWizardSelectedStep)
